import React from 'react';
import { Card, CardBody, Row, Col } from 'reactstrap';
import RevokeButton from '../../../containers/Buttons/RevokeButton';
import TogglePractitionerStatus from '../../../containers/Buttons/TogglePractitionerStatus';

const PractitionerControlCard = () => (
  <Card>
    <CardBody>
      <Row>
        <Col>
          <p>
            This button revokes the practitioners access to the current
            organization you are viewing.
          </p>
        </Col>
        <Col>
          <RevokeButton />
        </Col>
      </Row>
      <hr />
      <Row>
        <Col>
          <p>
            This option controls the practitioners access to the whole Website
          </p>
        </Col>
        <Col>
          <TogglePractitionerStatus />
        </Col>
      </Row>
    </CardBody>
  </Card>
);

export default PractitionerControlCard;
